export default __webpack_public_path__ + "static/media/avatar-smart-school.869d7103.png";